export function validarRut(rut: string): boolean {
  // Quitar puntos y convertir a mayúsculas
  rut = rut.replace(/\./g, "").toUpperCase();

  // Separar cuerpo y dígito verificador
  const [cuerpo, dv] = rut.split("-");

  if (!cuerpo || !dv) return false;

  // Validar formato: solo números en el cuerpo
  if (!/^\d+$/.test(cuerpo)) return false;

  // Calcular dígito verificador
  let suma = 0;
  let multiplo = 2;

  for (let i = cuerpo.length - 1; i >= 0; i--) {
    suma += parseInt(cuerpo[i], 10) * multiplo;
    multiplo = multiplo < 7 ? multiplo + 1 : 2;
  }

  const dvEsperado = 11 - (suma % 11);
  let dvFinal = dvEsperado === 11 ? "0" : dvEsperado === 10 ? "K" : dvEsperado.toString();

  return dvFinal === dv;
}

export function formatRut(rut: string): string {
  const clean = rut.replace(/[^0-9kK]/g, '').toUpperCase();
  const body = clean.slice(0, -1);
  const verifier = clean.slice(-1);
  return `${body}-${verifier}`;
}